module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Change password","input-2":"New password","update":"Update password","rule-2":"At least 6 chars"},"pt-BR":{"title":"Atualizar senha","input-2":"Nova senha","update":"Salvar nova senha","rule-2":"Mínimo 6 caracteres"}}')
  delete Component.options._Ctor
}
